import moment from "moment";
import "./InfluencerRating.scss";
import { toast } from "react-toastify";
import {
  CrossIcon,
  FbIcon,
  InstaIcon,
  StarIcon,
  TwitterIcon,
  UtubeIcon,
  VerifiedIcon,
  WalletIcon,
} from "../../../Assets/svgIcons";
import userTransperent from '../../../Assets/user_transperent.png'
import { Col, Modal, Row, Table } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import GiveRatingModal from "./GiveRatingModal/GiveRatingModal";
import { useEffect, useState } from "react";
import {
  createInfluencerInvitation,
  deleteInfluencerInvitation,
  getInfluencerFee,
  getInfluencerProfile,
  getInfluencerRating,
  getInfluencerTotalEarning,
  getTierInfo,
} from "../../../Services/prod/auth.service";
import LoadingChild from "../../../components/loading-child/loading-child.component";
import { CMAuctions } from "../../Public/billing-history/billing-history.styles";
import ReactPaginate from "react-paginate";
import { formatCommaNumbers } from "../../../Utils/common.utils";

const InfluencerRating = () => {
  // ******STATES******
  const limit = 10;
  const location = useLocation();
  const state = location?.state;
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("");
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [viewMore, setViewMore] = useState(null);
  const [profileData, setProfileData] = useState({
    feeData: {},
    profileData: {},
    ratingData: {},
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [invitationStatus, setInvitationStatus] = useState(state?.invitationStatus);

  const [tierInfo, setTierInfo] = useState({
    tier1_min: 0,
    tier1_max: 0,
    tier2_min: 0,
    tier2_max: 0,
    tier3_min: 0,
    tier3_max: 0,
  });

  function formatNumber(value) {
    const formatter = new Intl.NumberFormat("en-IN");
    if (value >= 1_000_000_000) {
      return formatter.format((value / 1_000_000_000).toFixed(1).replace(/\.0$/, "")) + "B";
    } else if (value >= 1_000_000) {
      return formatter.format((value / 1_000_000).toFixed(1).replace(/\.0$/, "")) + "M";
    } else if (value >= 1_000) {
      return formatter.format((value / 1_000).toFixed(1).replace(/\.0$/, "")) + "K";
    }
    return formatter.format(value);
  }

  const socialMedia = [
    {
      icon: <UtubeIcon />,
      data:
        profileData?.profileData?.influencer_socials?.youtube_monthly_views ||
        0,
      name: "Monthly Views",
    },
    {
      icon: <TwitterIcon />,
      data:
        profileData?.profileData?.influencer_socials?.twitter_followers || 0,
      name: "Followers",
    },
    {
      icon: <InstaIcon />,
      data:
        profileData?.profileData?.influencer_socials?.instagram_followers || 0,
      name: "Followers",
    },
    {
      icon: <FbIcon />,
      data:
        profileData?.profileData?.influencer_socials?.facebook_followers || 0,
      name: "Followers",
    },
  ];
  const actiondata = [
    {
      tier: "1",
      listeners: `${formatCommaNumbers(tierInfo?.tier1_min)} 
      to ${formatCommaNumbers(tierInfo?.tier1_max)}`,
      commission: profileData?.feeData?.influencer_fee
        ? profileData?.feeData?.influencer_fee?.first_tier_fee || 0
        : profileData?.feeData?.global_tier_fee?.first_tier_fee || 0,
    },
    {
      tier: "2",
      listeners: `${formatCommaNumbers(tierInfo?.tier2_min)}
      to ${formatCommaNumbers(tierInfo?.tier2_max)}`,
      commission: profileData?.feeData?.influencer_fee
        ? profileData?.feeData?.influencer_fee?.second_tier_fee || 0
        : profileData?.feeData?.global_tier_fee?.second_tier_fee || 0,
    },
    {
      tier: "3",
      listeners: `${formatCommaNumbers(tierInfo?.tier3_min)} 
      to ${formatCommaNumbers(tierInfo?.tier3_max)}`,
      commission: profileData?.feeData?.influencer_fee
        ? profileData?.feeData?.influencer_fee?.third_tier_fee || 0
        : profileData?.feeData?.global_tier_fee?.third_tier_fee || 0,
    },
  ];

  // ==================== TIER INFO ====================
  useEffect(() => {
    const tierInfo = async () => {
      const createFeesRes = await getTierInfo();
      setTierInfo(createFeesRes[0]);
    };
    tierInfo();
  }, []);

  // ==================== INITIAL CALL API --> FEE,PROFILE,EARNING,RATING ====================
  const handleProfile = async () => {
    try {
      const [feeRes, profileRes, ratingRes] = await Promise.all([
        getInfluencerFee(state?.userId),
        getInfluencerProfile(state?.userId),
        getInfluencerRating(page, limit, state?.userId),
      ]);
      if (
        feeRes?.status === 200 &&
        profileRes?.status === 200 &&
        ratingRes?.status === 200
      ) {
        setLoading(false);
        setProfileData({
          feeData: feeRes?.data,
          profileData: profileRes?.data,
          ratingData: ratingRes?.data,
        });
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error, "error");
    }
  };
  useEffect(() => {
    handleProfile();
  }, [update]);

  // ==================== CREATE INFLUENCER INVITATION {SINGLE} ====================
  const handleInviteSingle = async () => {
    try {
      if (state) {
        const invitePayload = {
          data: [
            {
              invited_to: state?.userId,
              invited_to_name: profileData?.profileData?.influencer_meta?.name,
              fee: state?.inviteFee,
            },
          ],
          auction_id: state?.auctionId,
          auction_name: state?.auctionName,
        };
        const inviteRes = await createInfluencerInvitation(invitePayload);
        if (inviteRes?.status === 200 || inviteRes?.status === 201) {
          setInvitationStatus("PENDING");
          toast.success(inviteRes?.message);
          setUpdate(!update);
          setModalOpen(false);
        } else {
          toast.error(inviteRes?.message);
          console.log("*** API ERROR ***");
        }
        console.log(inviteRes, "inviteRes");
      }
    } catch (error) {
      setModalOpen(false);
      console.log("Error in CreateInfluencer Api", error);
    }
  };

  // ==================== UN-INVITE INFLUENCER {SINGLE} ====================
  const handleUninviteSingle = async () => {
    try {
      if (state) {
        const unInviteRes = await deleteInfluencerInvitation(state?.userId,state?.auctionId);
        if (unInviteRes?.status === 200 || unInviteRes?.status === 201) {
          setInvitationStatus(null);
          toast.success(unInviteRes?.message);
          setUpdate(!update);
          setModalOpen(false);
          console.log(unInviteRes, "inviteRes");
        } else {
          toast.error(unInviteRes?.message);
          console.log("*** API ERROR ***");
        }
      }
    } catch (error) {
      setModalOpen(false);
      console.log("Error in CreateInfluencer Api", error);
    }
  };

  // *********** HANDLE PAGE  ***********
  const handlePage = ({ selected }) => {
    setPage(selected + 1);
  };
  return (
    <div className="influencer_rating_page">
      <h3>
        Influencer /{" "}
        <span>{profileData?.profileData?.influencer_meta?.name || ""}</span>{" "}
      </h3>
      {profileData?.profileData?.influencer_request === "PENDING" && (
        <div className="review_status">Pending Review</div>
      )}
      <div className="profile_img">
        <div className="profile_img_left">
          <img
            src={
              profileData?.profileData?.influencer_meta?.image || userTransperent
            }
            alt="profile"
          />
          {profileData?.profileData?.influencer_request === "APPROVED" && (
            <div className="profile_img_verified">
              <VerifiedIcon />
              <span>Verified</span>
              <p>
                Since{" "}
                {profileData?.profileData?.influencer_verified_date
                  ? moment(
                      profileData?.profileData?.influencer_verified_date
                    ).format("DD/MM/YYYY")
                  : "Not Verify"}
              </p>
            </div>
          )}
        </div>
        <div className="profile_img_right">
          {invitationStatus === null && (
            <>
              <button
                type="button"
                className="rating_btn green_btn"
                onClick={() => {
                  setStatus("INVITE");
                  setModalOpen(true);
                }}
              >
                Invite
              </button>
              <button type="button" className="rating_btn" disabled>
                Un-Invite
              </button>
            </>
          )}
          {invitationStatus === "PENDING" && (
            <>
              <button type="button" className="rating_btn green_btn" disabled>
                Pending
              </button>
              <button
                type="button"
                className="rating_btn"
                onClick={() => {
                  setStatus("UN-INVITE");
                  setModalOpen(true);
                }}
              >
                Un-Invite
              </button>
            </>
          )}
          {invitationStatus === "ACCEPTED" && (
            <button type="button" className="rating_btn green_btn" disabled>
              Accepted
            </button>
          )}
          {invitationStatus === "REJECTED" && (
            <button type="button" className="rating_btn red_btn" disabled>
              Rejected
            </button>
          )}
        </div>
      </div>
      <div className="about_box">
        <h4>About Me</h4>
        <p className="desc_txt">
          {profileData?.profileData?.influencer_meta?.description}
        </p>
        <div className="about_details">
          <Row>
            <Col md={4}>
              <div className="about_details_box social_network">
                {loading ? (
                  <LoadingChild />
                ) : (
                  <>
                    <h5>My Social Network</h5>
                    <div className="social_network_links">
                      {socialMedia.map((item, index) => {
                        return (
                          <Link key={index} rel="noreferrer">
                            {item.icon}
                            <div>
                              {formatNumber(item?.data)}
                              <span>{item.name}</span>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col md={4}>
              <div className="about_details_box rating">
                {loading ? (
                  <LoadingChild />
                ) : (
                  <>
                    <h5>My Rating & Reviews</h5>
                    <div className="rating_in">
                      <h6>{profileData?.ratingData?.average_rating || 0}</h6>
                      <div className="rating_in_stars">
                        <div className="rating_in_stars_original">
                          {Array.from({ length: 5 }).map((_, index) => {
                            const rating =
                              profileData?.ratingData?.average_rating || 0;
                            const showRating = Math.floor(rating); // Number of fully filled stars
                            const fractionalPart = rating - showRating; // Fractional part of the rating
                            return (
                              <StarIcon
                                className={`active star_icon`}
                                style={{
                                  clipPath: `inset(0 ${
                                    index < showRating
                                      ? 0 // Fully filled
                                      : index === showRating // Partially filled star
                                      ? 100 - fractionalPart * 100
                                      : 100 // Completely unfilled
                                  }% 0 0)`,
                                }}
                                key={index}
                              />
                            );
                          })}
                        </div>
                        <div className="rating_in_stars_copy">
                          {Array.from({ length: 5 }).map((_, index) => {
                            return (
                              <StarIcon className={`star_icon`} key={index} />
                            );
                          })}
                        </div>
                      </div>
                      <p>{profileData?.ratingData?.count} ratings</p>
                    </div>
                  </>
                )}
              </div>
            </Col>
            {/* <Col md={4}>
              <div className="about_details_box financial">
                {loading ? (
                  <LoadingChild />
                ) : (
                  <>
                    <h5>Financial</h5>
                    <WalletIcon />
                    <p>Total earnings</p>
                    <h6>
                      {profileData?.financialData?.total_earnings
                        ? `$${profileData?.financialData?.total_earnings}`
                        : "$0.00"}
                    </h6>
                  </>
                )}
              </div>
            </Col> */}
          </Row>
        </div>
      </div>
      <hr className="custom_hr" />
      {loading ? (
        <LoadingChild />
      ) : (
        <>
          <div className="my_finance_tab_box">
            <h3>Auction Commissions</h3>
            <p>
              The auction commission is the fee the influencer charges for
              generating traffic leading to successful bids, determined by your
              auction tier as set by MusicBull
            </p>
            <Table className="auction_table" responsive>
              <thead>
                <tr>
                  <th>Tier</th>
                  <th>Monthly Listeners</th>
                  <th>Commission</th>
                </tr>
              </thead>
              <tbody>
                {actiondata?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>Tier {item.tier}</td>
                      <td>{item.listeners}</td>
                      <td>
                        {" "}
                        <span className="commission_box">
                          {item.commission}
                        </span>
                        %{" "}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div className="ratings">
            <h3>My Rating & Reviews</h3>
            <button
              onClick={() => setShow(true)}
              type="button"
              className="rating_btn green_btn"
            >
              Submit Review
            </button>
            <GiveRatingModal
              show={show}
              update={update}
              setUpdate={setUpdate}
              handleClose={() => setShow(false)}
              userId={profileData?.profileData?.user_id}
            />
            <div className="rating_details">
              <h3>Rating Details </h3>
              <ul>
              {profileData?.ratingData &&
              profileData?.ratingData?.rows?.length > 0 ? (
                profileData?.ratingData?.rows?.map((data,i) => (
                    <li>
                      <div className="rating_details_box">
                        <div className="rating_details_box_stars">
                          {Array.from({ length: 5 }).map((_, index) => (
                            <StarIcon
                              className={`${
                                index + 1 <= data?.rating ? "active" : ""
                              } star_icon`}
                              key={index}
                            />
                          ))}
                          <p>{data?.rating ? data?.rating : 0}</p>
                        </div>
                        <p className="desc_txt">
                          {data?.commit ? data?.commit : "N/A"}
                        </p>
                        {data?.replies?.length !== 0 && (
                        <>
                          {viewMore !== i && (
                            <button
                              onClick={() => setViewMore(i)}
                              type="button"
                              className="view_btn"
                            >
                              View Comment
                            </button>
                          )}
                          {viewMore === i && (
                            <p
                              onClick={() => setViewMore(null)}
                              className="desc_txt reply_txt"
                            >
                              {data?.replies[0]?.commit}
                            </p>
                          )}
                        </>
                      )}
                      </div>
                    </li>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      padding: "20px",
                      fontSize: "18px",
                    }}
                  >
                    No Records Found
                  </p>
                </div>
              )}
              </ul>
            </div>
            {profileData?.ratingData?.count > limit && (
              <CMAuctions>
                <section className="pagination custom_pagination">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    previousLabel="<"
                    onPageChange={handlePage}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(
                      profileData?.ratingData?.count / limit
                    )}
                    renderOnZeroPageCount={null}
                  />
                </section>
              </CMAuctions>
            )}
          </div>
        </>
      )}
      {modalOpen && (
        <Modal
          show={modalOpen}
          centered
          backdropClassName="invite_external_influencer_modal_bg"
          className="invite_confirmation_modal"
        >
          <button
            onClick={() => setModalOpen(false)}
            className="cross_btn"
            type="button"
          >
            <CrossIcon />
          </button>
          <h3>{status} REQUEST</h3>
          <p className="desc_txt">
            Do you want to {status === "INVITE" ? "invite" : "un-invite"} this
            influencer?
          </p>
          <div className="d-flex align-items-center justify-content-center">
            <button
              className="cancel_btn custom_btn me-3"
              onClick={() => setModalOpen(false)}
            >
              No{" "}
            </button>
            <button
              className="green_btn custom_btn"
              onClick={
                status === "INVITE" ? handleInviteSingle : handleUninviteSingle
              }
            >
              Yes{" "}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default InfluencerRating;
